module.exports = __webpack_public_path__ + "static/media/happyFeelings.b5c413d1.jpeg";